import React from 'react'

import { ZariContext } from '_zari/context'
import { Divider, Col, Row, Button } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

const ReporteExcelSection = () => {
  const __zariContext = React.useContext(ZariContext)

  const onClick = React.useCallback(() => {
    __zariContext.loader.open('Descargando excel reporte de detracciones')

    AsientoContableService.descargarReporteExcelDetracciones()
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
        __zariContext.toast('success', 'Reporte descargado.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  return (
    <>
      <Divider title='Reportes Excel' />
      <Row>
        <Col md={12}>
          <Button outline tiny onClick={onClick}>
            Descargar Excel
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(ReporteExcelSection)
